(() => {
function $7bec22ef1ef4818f$var$initPlayer() {
    const playerContainer = document.getElementById("player");
    const playerLinks = document.querySelectorAll("[data-player]");
    document.getElementById("player-close")?.addEventListener("click", (event)=>{
        event.preventDefault();
        playerContainer.innerHTML = "";
    });
    playerLinks.forEach((playerLinkElement)=>{
        playerLinkElement.addEventListener("click", (event)=>{
            playerContainer.innerHTML = "";
            event.preventDefault();
            const playerIframeContent = playerLinkElement.querySelector("[data-player-content]")?.textContent || "";
            playerContainer.innerHTML = playerIframeContent;
        });
    });
}
function $7bec22ef1ef4818f$var$init() {
    $7bec22ef1ef4818f$var$initPlayer();
}
document.addEventListener("DOMContentLoaded", $7bec22ef1ef4818f$var$init);

})();
//# sourceMappingURL=main.js.map
